module.exports = __webpack_public_path__ + "static/media/send_button.f1b33d8e.svg";